import { AdditionalPageService } from "@/common/api.service"
import { FETCH_ADDITIONAL_PAGES, FETCH_INDIVIDUAL_ADDITIONAL_PAGE, ADD_ADDITIONAL_PAGE_RESOURCE, DELETE_ADDITIONAL_PAGE, FETCH_PAGE_RESOURCES, RESET_STATE, ADD_COMPANY_PAGE, UPDATE_COMPANY_PAGE, DELETE_PAGE_RESOURCE, FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU} from "./actions.type"
import { SET_ADDITIONAL_PAGES, SET_RESOURCES, SET_INDIVIDUAL_ADDITIONAL_PAGE, SET_ERROR_PAGE, SET_ADDITIONAL_PAGES_ON_SIDE_MENU, STATE_RESET, RESET_ALL_ADDITIONAL_PAGES_DATA } from "./mutations.type"

const initialState = () => {
    return {
        additionalpages: [],
        additionalpagessidemenu:[],
        resources: [],
        individualadditionalpage: [],
        pageerrors: null,
    }
}

let state = initialState()

const getters = {
    additionalpages(state) {
        return state.additionalpages
    },
    additionalpagessidemenu(state){
        return state.additionalpagessidemenu
    },
    individualadditionalpage(state) {
        return state.individualadditionalpage
    },
    resources(state) {
        return state.resources
    },
}

const actions = {
    async [FETCH_ADDITIONAL_PAGES_ON_SIDE_MENU](context, slug) {
        const { data } = await AdditionalPageService.getPages(slug)
        context.commit(SET_ADDITIONAL_PAGES_ON_SIDE_MENU, data.data)
        return data;
    },
    async [FETCH_ADDITIONAL_PAGES](context, slug) {
        const { data } = await AdditionalPageService.getPages(slug)
        context.commit(SET_ADDITIONAL_PAGES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_ADDITIONAL_PAGE](context, slug) {
        const { data } = await AdditionalPageService.getPages(slug)
        context.commit(SET_INDIVIDUAL_ADDITIONAL_PAGE, data.data)
        return data;
    },  
    async [ADD_ADDITIONAL_PAGE_RESOURCE](context, payload) {
        return await AdditionalPageService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_PAGE, error.response.data.errors)
        });
    },  
    async [DELETE_ADDITIONAL_PAGE] (context, id) {
        return await AdditionalPageService.deletePage(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_PAGE, error.response.data.errors)
        });
    }, 
    async [FETCH_PAGE_RESOURCES](context, slug) {
        const { data } = await AdditionalPageService.get(slug)
        context.commit(SET_RESOURCES, data.data)
        return data;
    }, 
    async [ADD_COMPANY_PAGE](context, payload) {
        return await AdditionalPageService.createPage(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_PAGE, error.response.data.errors)
        });
    },  
    async [UPDATE_COMPANY_PAGE](context, payload) {
        return await AdditionalPageService.updatePage(payload, payload.id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_PAGE, error.response.data.errors)
        });
    },  
    async [DELETE_PAGE_RESOURCE] (context, id) {
        return await AdditionalPageService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_PAGE, error.response.data.errors)
        });
    }, 
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }
    // [ADDITIONAL_PAGES_RESET_STATE]({ commit }) {
    //     // Object.assign(state, initialState())
    //     commit(RESET_ADDITIONAL_PAGE_STATE);
    // }
}

const mutations = {
    [SET_ERROR_PAGE](state, error) {
        state.pageerrors = error
    }, 
    [SET_ADDITIONAL_PAGES_ON_SIDE_MENU](state, data) {
        state.additionalpagessidemenu = data
    },     
    [SET_ADDITIONAL_PAGES](state, data) {
        state.additionalpages = data
    },
    [SET_RESOURCES](state, data) {
        state.resources = data
    },
    [SET_INDIVIDUAL_ADDITIONAL_PAGE](state, individualadditionalpage) {
        state.individualadditionalpage = individualadditionalpage
    },  
    [STATE_RESET](state) {
        state.individualadditionalpage = [] //do not change this function as we should not clear to initial state
        state.pageerrors = []
    },
    [RESET_ALL_ADDITIONAL_PAGES_DATA](state) {
        state.additionalpages = []
        state.additionalpagessidemenu = []
        state.resources = []
        state.individualadditionalpage = []
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};

